import styled from "@emotion/styled";
import { keyframes } from "@emotion/css";
import type { FC, ReactNode } from "react";

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const sunRise = keyframes`
  0% {
    top: 120%;
  }
  100% {
    top: 50%;
  }
`;

const skyShift = keyframes`
  0% {
    top: 60%;
  }
  100% {
    top: 20%;
  }
`;

const Container = styled.div`
  label: SunriseBackground;
  background: #80aeff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  opacity: 0;
  overflow: hidden;
  animation: ${fadeIn} 0.3s ease-in-out forwards;

  // sky background
  &::before {
    background: var(
      --Sunrise-Vertical-Regular,
      linear-gradient(0deg, #80aeff 13.49%, #f7bde6 51.22%, #ffbd70 85.11%)
    );
    width: 370%;
    aspect-ratio: 1.2;
    content: "";
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 1;
    animation: ${skyShift} 12s cubic-bezier(0.05, 0.7, 0.1, 1) forwards;
  }

  // sun
  &::after {
    width: 570%;
    aspect-ratio: 1;
    content: "";
    border-radius: 50%;
    position: absolute;
    top: 85%;
    left: 50%;
    transform: translate(-50%, 0);
    z-index: 2;
    background: linear-gradient(
      180deg,
      #ffbd70 13.49%,
      #f7bde6 51.22%,
      #ffbd70 85.11%
    );
    animation: ${sunRise} 8s cubic-bezier(0.05, 0.7, 0.1, 1) forwards;
  }
`;

interface SunriseBackgroundProps {
  children?: ReactNode;
}

const SunriseBackground: FC<SunriseBackgroundProps> = ({ children }) => {
  return <Container>{children}</Container>;
};

export default SunriseBackground;
